import api from './'

export default {

    /**
     * Delete license
     * @param licenseId
     */
    delete(licenseId) {
        return api
            .delete(`/licenses/${licenseId}`)
            .then(response => {
                return response.data
            })
    },

}
